<template>
    <div class="tw-px-4 tw-py-3">
        <div
            v-if="!matrix || matrix.length === 0"
            class="tw-text-sm tw-text-gray-400 tw-italic"
        >
            No approval data.
        </div>
        <template v-else>
            <div
                v-for="(approvers, level) in grouped"
                :key="level"
                class="tw-mb-3"
                style="margin-bottom: 12px;"
            >
                <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
                    <span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; border-radius:50%; background:#dbeafe; color:#1d4ed8; font-size:11px; font-weight:700;">{{ level }}</span>
                    <span style="font-size:11px; font-weight:600; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em;">Level {{ level }}</span>
                </div>
                <div style="display:flex; flex-wrap:wrap; gap:8px; padding-left:28px;">
                    <div
                        v-for="(m, i) in approvers"
                        :key="i"
                        style="display:flex; align-items:center; gap:8px; padding:6px 12px; border-radius:8px; border:1px solid; font-size:12px;"
                        :style="cardStyle(m.app_status)"
                    >
                        <span
                            style="display:inline-flex; align-items:center; justify-content:center; width:24px; height:24px; border-radius:50%; color:#fff; font-size:11px; font-weight:700; flex-shrink:0;"
                            :style="{ background: avatarBg(m) }"
                        >{{ initial(m) }}</span>
                        <div>
                            <div style="font-weight:600; color:#374151;">{{ displayName(m) }}</div>
                            <div style="display:flex; align-items:center; gap:4px; margin-top:2px;">
                                <i
                                    :class="statusIcon(m.app_status)"
                                    :style="{ color: statusColor(m.app_status) }"
                                ></i>
                                <span :style="{ color: statusColor(m.app_status) }">{{ statusLabel(m.app_status) }}</span>
                            </div>
                            <div v-if="m.app_comment" style="color:#6b7280; margin-top:2px; font-style:italic;">"{{ m.app_comment }}"</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { groupBy } from "lodash";

export default {
    name: "ApprovalMatrixExpand",
    props: {
        matrix: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        grouped() {
            return groupBy(this.matrix, "app_level");
        },
        currentUserId() {
            return this.$store.state.authUser.user.user_id;
        }
    },
    methods: {
        isMe(m) {
            return m.app_user_id === this.currentUserId;
        },
        initial(m) {
            if (this.isMe(m)) return "Y";
            const name = m.employee
                ? (m.employee.employee_name_en || m.employee.employee_name_kh)
                : null;
            return name ? name.charAt(0).toUpperCase() : "?";
        },
        displayName(m) {
            if (this.isMe(m)) return "You";
            if (!m.employee) return m.app_user_id;
            return m.employee.employee_name_en || m.employee.employee_name_kh || m.app_user_id;
        },
        cardStyle(status) {
            if (status === 2) return { background: "#f0fdf4", borderColor: "#bbf7d0" };
            if (status === 3) return { background: "#fef2f2", borderColor: "#fecaca" };
            return { background: "#f9fafb", borderColor: "#e5e7eb" };
        },
        avatarBg(m) {
            if (this.isMe(m)) return "#6366f1";
            if (m.app_status === 2) return "#22c55e";
            if (m.app_status === 3) return "#ef4444";
            return "#9ca3af";
        },
        statusColor(status) {
            if (status === 2) return "#16a34a";
            if (status === 3) return "#dc2626";
            return "#9ca3af";
        },
        statusIcon(status) {
            if (status === 2) return "fas fa-check-circle";
            if (status === 3) return "fas fa-times-circle";
            return "fas fa-clock";
        },
        statusLabel(status) {
            if (status === 2) return "Approved";
            if (status === 3) return "Rejected";
            return "Pending";
        }
    }
};
</script>
